"use client";

import { memo } from "react";
import Toast from "~/components/toast/Toast";
import {
  ADDRESS_UPDATED,
  CHANGES_SAVED,
  COPIED_TO_CLIPBOARD,
  ERROR_DOWNLOADING_INVOICE,
  ERROR_OCCURRED_WHILE_UPDATING,
  ERROR_OCCURRED_WHILE_UPLOADING_FILES,
  ERROR_NO_CONTACT_FOUND_FOR_SUPPLIER,
  ITEM_DELIVERY_DATE_HAS_CHANGED,
  ITEM_HAS_BEEN_REMOVED,
  ITEM_QUANTITY_HAS_CHANGED,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CREATE_SUCCESS,
  FINALIZED,
  BULK_EDIT_SELECT_MIN_RECORDS,
  OFFER_CREATED,
  OFFER_UPDATED,
  BULK_UPDATE_SUCCESS,
} from "~/constants/queryParams";
import { useI18n } from "~/locales/client";
import { ToastTypeEnum } from "~/types-and-enums/toastTypes";

/**
 * Display's Changes saved toast and/or please try again toast
 */
const DisplayToasts = memo(() => {
  const translate = useI18n();
  return (
    <>
      <Toast
        headerText={translate("general.changes-saved")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={CHANGES_SAVED}
        duration={2000}
      />
      <Toast
        headerText={translate("general.address-updated")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ADDRESS_UPDATED}
        duration={2000}
      />
      <Toast
        headerText={translate("general.quantity-has-changed")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ITEM_QUANTITY_HAS_CHANGED}
        duration={2000}
      />
      <Toast
        headerText={translate("general.delivery-date-has-changed")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ITEM_DELIVERY_DATE_HAS_CHANGED}
        duration={2000}
      />
      <Toast
        headerText={translate("general.item-removed-successfully")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={ITEM_HAS_BEEN_REMOVED}
        duration={2000}
      />
      <Toast
        headerText={translate("general.password-changed")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={PASSWORD_CHANGE_SUCCESS}
        duration={3000}
      />
      <Toast
        headerText={translate("general.password-created")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={PASSWORD_CREATE_SUCCESS}
        duration={3000}
      />
      <Toast
        headerText={translate("pq-ingestion.finalized")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={FINALIZED}
        duration={2000}
      />
      <Toast type={ToastTypeEnum.Error} toastOpenSearchParam="errorText" duration={1500} />
      <Toast
        headerText={translate("error.something-went-wrong-while-updating")}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={ERROR_OCCURRED_WHILE_UPDATING}
        duration={2000}
      />
      <Toast
        headerText={translate("error.error-occurred-while-downloading-invoice")}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={ERROR_DOWNLOADING_INVOICE}
        duration={2000}
      />
      <Toast
        headerText={translate("general.copied-to-clipboard")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={COPIED_TO_CLIPBOARD}
        duration={2000}
      />
      <Toast
        headerText={translate("error.error-occurred-while-uploading-files")}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={ERROR_OCCURRED_WHILE_UPLOADING_FILES}
        duration={2000}
      />
      <Toast
        headerText={translate("pq-ingestion.select-at-least-two-records")}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={BULK_EDIT_SELECT_MIN_RECORDS}
        duration={2000}
      />
      <Toast
        headerText={translate("error.no-contact-found-for-supplier")}
        type={ToastTypeEnum.Error}
        toastOpenSearchParam={ERROR_NO_CONTACT_FOUND_FOR_SUPPLIER}
        duration={3000}
      />
      <Toast
        headerText={translate("single-product-offering.offer-created")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={OFFER_CREATED}
        duration={3000}
      />
      <Toast
        headerText={translate("update-product-offering.offer-updated")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={OFFER_UPDATED}
        duration={3000}
      />
      <Toast
        headerText={translate("stock-list.bulk-update-success")}
        type={ToastTypeEnum.Success}
        toastOpenSearchParam={BULK_UPDATE_SUCCESS}
        duration={3000}
      />
    </>
  );
});

DisplayToasts.displayName = "DisplayToasts";

export default DisplayToasts;
